import React, { Component } from 'react'
import Axios from 'axios'
import { backImageURL } from './../const'
import { connect } from 'react-redux'
import { changeBG } from './../actions/theme'
import { Offline, Online } from "react-detect-offline";

class Waiting extends Component {
  componentDidMount() {
    this._getBackground()
  }

  _getBackground() {
    console.log('Getting background image', this.props.port)
    Axios.post(backImageURL, {
      port: this.props.port,
    })
      .then(resp => {
        if (resp.data.bg) {
          console.log('Get new image, data=' + JSON.stringify(resp.data))
          return this.props.changeBG(resp.data.bg)
        }
        if (resp.data.image) {
          console.log('Get new image, data=' + JSON.stringify(resp.data))
          return this.props.changeBG(resp.data.image)
        }
        console.log(
          'Not image in axios response, data=' + JSON.stringify(resp.data)
        )
      })
      .catch(err => {
        console.log('ERROR in axios image get, err=' + err.toString())
      })
  }

  render() {
    return (
      <div className="App">
          <header className="App-header">
            <Offline>
              <div className="row" style={{ height: '100vh', border: '15px solid red', backgroundColor: 'red' }}>
                <img src={this.props.bg} alt="logo" style={{width: '100%', height: '92vh'}} />
                <div className="row valign-wrapper" style={{ height: '5vh', color: 'white', width: '100%' }}>
                  <div className="col s12 center-align">Offline</div>
                </div>
              </div>
            </Offline>
            <Online>
              <div className="row">
                <img src={this.props.bg} alt="logo" className="full-screen" />
              </div>
            </Online>
          </header>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  bg: ownProps.bg || state.theme.bg,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeBG: url => dispatch(changeBG(url)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Waiting)
